import PropTypes from "prop-types";
import React from "react";
import styles from "./styles";

import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Typography,
	withStyles
} from "@material-ui/core";

import { ExpandMore as ExpandMoreIcon } from "@material-ui/icons";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Card } from "../index";
import { canvas as canvasStore } from "../../store";
import { version } from "../../config";

class Results extends React.Component {
	render() {
		const {
			classes,
			data,
			all,
			pois,
			frame,
			setFrame,
			setHoveredLot
		} = this.props;
		const canvasPOIS = all.pois;
		const keys = Object.keys(pois);

		return (
			<div>
				{Object.keys(data).map(name => {
					const typesData = data[name];
					if (Object.keys(typesData).length === 0) {
						return null;
					}

					let pieces = name.replace(/(?!\/)\D+/gimu, "");
					if (name === "ST" || name === "st") {
						pieces = 1;
					}
					return (
						<Accordion
							classes={{
								root: classes.panelRoot
							}}
							key={name}
						>
							<AccordionSummary
								classes={{
									root: classes.panelSummaryRoot,
									expanded: classes.expanded
								}}
								expandIcon={
									<ExpandMoreIcon
										classes={{
											root: classes.panelSummaryIcon
										}}
									/>
								}
							>
								<Typography className={classes.panelSummaryHeading}>
									{version.office
										? name
										: `${pieces} pièces (${Object.keys(typesData).length})`}
								</Typography>
							</AccordionSummary>
							<AccordionDetails
								classes={{
									root: classes.panelDetails
								}}
							>
								{Object.keys(typesData).map(item => {
									const { lot } = typesData[item];
									const key = keys.indexOf(lot);
									if (!canvasPOIS[key]) {
										return null;
									}
									return (
										<Card
											className={classes.card}
											item={typesData[item]}
											key={`${lot}`}
											coordinates={
												canvasPOIS[key][lot]
													? canvasPOIS[key][lot].coordinates
													: null
											}
											frame={frame}
											setFrame={setFrame}
											setHoveredLot={setHoveredLot}
										/>
									);
								})}
							</AccordionDetails>
						</Accordion>
					);
				})}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	...state.filtered[state.helpers.building],
	...state.canvas[state.helpers.building],
	pois: state.pois[state.helpers.building],
	...state.helpers
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setFrame: canvasStore.setFrame,
			setHoveredLot: canvasStore.setHoveredLot
		},
		dispatch
	);

Results.propTypes = {
	classes: PropTypes.object.isRequired,
	data: PropTypes.object.isRequired
	// settings: PropTypes.object
};

Results.defaultProps = {
	// settings: null
};

export default withStyles(styles)(
	connect(mapStateToProps, mapDispatchToProps)(Results)
);
